import styled from 'styled-components';
import { FlexBox } from '@ardoq/layout';
import { colors, radius } from '@ardoq/design-tokens';
import { ComponentDecoratorAsIcon } from '@ardoq/decorators';
import { TruncatedTextPopover } from '@ardoq/popovers';
import { CurrentToolbarContext } from './types';
import { header4 } from '@ardoq/typography';

const Container = styled(FlexBox)`
  ${header4};
  left: 50%;
  top: 0;
  transform: translate(-50%, -100%);
  animation: 0.2s fly-in;
  border: 1px solid ${colors.borderAction};
  border-bottom: 0;
  border-radius: ${radius.medium} ${radius.medium} 0 0;
  opacity: 1;
  z-index: 1;

  @keyframes fly-in {
    from {
      opacity: 0;
      transform: translate(-50%, 0);
    }
  }
`;

const CurrentSelection = ({
  currentContext,
}: {
  currentContext: CurrentToolbarContext;
}) => (
  <Container
    position="absolute"
    maxWidth="80%"
    backgroundColor="surfaceDefaultSubtle"
    paddingX="medium"
    paddingY="small"
    align="center"
    gap="small"
  >
    {currentContext.representationData && (
      <ComponentDecoratorAsIcon {...currentContext.representationData} />
    )}
    <TruncatedTextPopover>
      {currentContext?.label ?? 'No selection'}
    </TruncatedTextPopover>
  </Container>
);

export { CurrentSelection };
